import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ProveedorCreateInterface } from "../../interfaces/proveedorInterfaces/ProveedorCreate.interface";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";
import { useToast } from "vue-toastification";
import { ProveedorCreateAction } from "../../actions/proveedorActions";

const toast = useToast();

export function useProveedorCreate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (proveedor: ProveedorCreateInterface) =>
      ProveedorCreateAction(proveedor),

    onSuccess:async (response: ApiResponse<ProveedorInterface>) => {
      // Invalida la lista para refrescar los datos
      await queryClient.invalidateQueries({ queryKey: ["ProveedoresList"] });

      toast.success("Proveedor creado correctamente");
        if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al crear proveedor");
        if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
